module.exports = __webpack_public_path__ + "img/right-registerpage.962a55bd.png";